export default __webpack_public_path__ + "static/media/photo_5282747746622312908_y.e7170125.jpg";